import logo from "assets/logo.png";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Tooltip } from "antd";

import * as N from "./navbarElements";
import PageIcon from "@rsuite/icons/Page";
import { Buttons, MainContainer, ToastMessage } from "components/common";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Container } from "react-bootstrap";
import { networkObj } from "data/networks";
import { switchNetwork } from "hooks";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  logoutBlockchain,
  updateChainId,
} from "store/redux/slices/web3/connectWeb3Slice";
import { MainNavbar } from "./navbarElements";
import { useLocation } from "react-router-dom";
import { Dropdown } from "rsuite";

import walletIcon from "assets/walletIcon.png";
import { connectModelSlice } from "store/redux/slices/helperSlices/modelSlice";

import MainModel from "components/modal/mainModel";
import { ContractUtility } from "utility";

const Navbar = () => {
  const { web3, chainId } = useAppSelector((state) => state.web3Connect);

  const [networkChainId, setNetworkChainId] = useState("");

  const dispatch = useAppDispatch();

  const handleMenuClick = async (item) => {
    await switchNetwork(web3, item);
  };

  const walletHandle = () => {
    dispatch(connectModelSlice(true));
  };

  const location = useLocation();

  const { pathname } = location;

  useEffect(() => {
    if (web3) {
      setNetworkChainId(chainId);
    }
  }, [web3]);

  const logoutHandle = () => {
    dispatch(logoutBlockchain());
    dispatch(connectModelSlice(false));
    ToastMessage("Wallet Disconnected Successfully", "", "success");
  };

  return (
    <MainNavbar className="mainNavbar">
      <MainModel />
      <N.PrimaryNavbar
        // className={
        //   navbarHide ? "navbarPrimary primaryHidden" : "navbarSecondary"
        // }
        collapseOnSelect
        bg="light"
        expand="lg"
      >
        <MainContainer>
          <N.PrimaryNavbar.Brand as={Link} to="/">
            <N.NavLogo src={logo}></N.NavLogo>
          </N.PrimaryNavbar.Brand>
          <N.PrimaryNavbar.Toggle aria-controls="navbarScroll" />
          <N.NavbarCollapse id="navbarScroll">
            <N.Navs navbarScroll>
              <N.Navs.Link
                as={Link}
                to="/all-nfts"
                className={pathname === "/all-nfts" ? "active" : "noActive"}
              >
                Explore
              </N.Navs.Link>
              <N.Navs.Link
                as={Link}
                to="/collection-all"
                className={
                  pathname === "/collection-all" ? "active" : "noActive"
                }
                href="/collection-all"
              >
                Collections
              </N.Navs.Link>
              <N.Navs.Link
                as={Link}
                to="/rewards"
                href="/rewards"
                className={pathname === "/rewards" ? "active" : "noActive"}
              >
                Rewards
              </N.Navs.Link>
            </N.Navs>
            <N.Navs.Link as={Link} to="/profile">
              <N.UserIcon />
            </N.Navs.Link>

            <N.DropdownMain>
              <N.NetworkDropdown
                title={
                  chainId
                    ? (Number(chainId) === 137 && "Polygon") ||
                      (Number(chainId) == 1 && "Ethereum") ||
                      (Number(chainId) === 4 && "Rinkeby")
                    : "Switch Network"
                }
                disabled={web3 ? false : true}
              >
                {networkObj.map((item) => (
                  <>
                    <Dropdown.Item
                      icon={
                        <item.image
                          style={{ marginRight: "5px", marginBottom: "2px" }}
                        />
                      }
                      eventKey={item.value}
                      onSelect={(e) => handleMenuClick(e)}
                    >
                      {item.name}
                    </Dropdown.Item>
                  </>
                ))}
              </N.NetworkDropdown>
            </N.DropdownMain>

            <Tooltip
              placement="bottom"
              title={web3 ? "Connected" : "Connect Wallet"}
            >
              {web3 ? (
                <N.WalletImg
                  src={walletIcon}
                  width={20}
                  onClick={logoutHandle}
                />
              ) : (
                <N.WalletImg
                  src={walletIcon}
                  width={20}
                  onClick={walletHandle}
                />
              )}
            </Tooltip>
          </N.NavbarCollapse>
        </MainContainer>
      </N.PrimaryNavbar>
    </MainNavbar>
  );
};

export default Navbar;
